<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16zE5xm/tc-custom/9781504026475.jpg?1703222301381" alt="This image is the cover for the book Dragon's Teeth, The Lanny Budd Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dragon's Teeth, The Lanny Budd Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>Pulitzer Prize Winner: An American in Germany fights against the rising tide of Nazi terror in this monumental saga of twentieth-century world history.</b><br/><br/> In the wake of the 1929 stock market crash, Lanny Budd’s financial acumen and his marriage into great wealth enable him to continue the lifestyle he has always enjoyed.  But the devastation the collapse has wrought on ordinary citizens has only strengthened Lanny’s socialist ideals—much to the chagrin of his heiress wife, Irma, a confirmed capitalist.<br/>  <br/> In Germany to visit relatives, Lanny encounters a disturbing atmosphere of hatred and jingoism. His concern over the growing popularity of the Nazi Party escalates when he meets Adolf Hitler, the group’s fanatical leader, and the members of his inner circle. But Lanny’s gravest fear is the threat a national socialist government poses to the German Jewish family of Hansi, the musician husband of Lanny’s sister, Bess—a threat that will impel the international art dealer to risk his wealth, his future, even his life in a courageous attempt to rescue his loved ones from a terrible fate.<br/>  <br/> Winner of the 1943 Pulitzer Prize for Fiction, <i>Dragon’s Teeth </i>brilliantly captures the nightmarish march toward the Second World War. An astonishing mix of history, adventure, and romance, the Lanny Budd Novels are a testament to the breathtaking scope of Upton Sinclair’s vision and his singular talents as a storyteller.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Upton Sinclair
      </h2>
      
      <p class="authorDescription body article">Upton Sinclair (1878&ndash;1968) was a Pulitzer Prize&ndash;winning author, activist, and politician whose novel&#160;<I>The Jungle </I>(1906)&#160;led to the passage of the Federal Meat Inspection Act and the Pure Food and Drug Act. Born into an impoverished family in Baltimore, Maryland, Sinclair entered City College of New York five days before his fourteenth birthday. He wrote dime novels and articles for pulp magazines to pay for his tuition, and continued his writing career as a graduate student at Columbia University. To research <I>The Jungle</I>, he spent seven weeks working undercover in Chicago&rsquo;s meatpacking plants. The book received great critical and commercial success, and Sinclair used the proceeds to start a utopian community in New Jersey. In 1915, he moved to California, where he founded the state&rsquo;s ACLU chapter and became an influential political figure, running for governor as the Democratic nominee in 1934. Sinclair wrote close to one hundred books during his lifetime, including <I>Oil!&#160;</I>(1927), the inspiration for the 2007 movie&#160;<I>There Will Be Blood</I>; <I>Boston </I>(1928), a documentary novel revolving around the Sacco and Vanzetti case; <I>The Brass Check</I>, a muckraking expos&eacute; of American journalism, and the eleven novels in Pulitzer Prize&ndash;winning Lanny Budd series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ede91692